import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { SET_SHOULD_UPDATE_BIG_NUMBERS } from '../../../../reducers/gerenciadorPrecos/bigNumbers/shouldUpdateBigNumbers';

export type BigNumbersRefresh = {
  refreshBigNumbers: () => Promise<void>;
  markBigNumbersOutdated: () => void;
};

export const useBigNumbersRefresh = (): BigNumbersRefresh => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  const refreshBigNumbers = useCallback(async (): Promise<void> => {
    dispatch(SET_SHOULD_UPDATE_BIG_NUMBERS(false));
    await Promise.all([queryClient.invalidateQueries(['totalPrices']), queryClient.invalidateQueries(['variationPrice'])]);
  }, [dispatch, queryClient]);

  // Edições pontuais não recalculam sozinhas: só exibem o "Cálculos desatualizados · Atualizar", igual à célula
  const markBigNumbersOutdated = useCallback((): void => {
    dispatch(SET_SHOULD_UPDATE_BIG_NUMBERS(true));
  }, [dispatch]);

  return { refreshBigNumbers, markBigNumbersOutdated };
};
